import {SimplePaymentHistory} from "./simple_payment_history";

// shows the group's current monthyl bill info.
export class NextDueDate extends HTMLElement {

  constructor() {
    super();
  }

  async connectedCallback() {
    this.groupId = this.getAttribute('groupId')
    let date = this.getAttribute('date')
    date = parseInt(date)
    this.innerHTML = `
      <style>
      </style>

      <div class="light-colored-container">
        <h4>Next payment due:</h4>
        <h3 id="next_due_date">${moment(date).format('MMM DD')}</h3>
        <a 
          href="#"
          id='view_payment_history'
        > 
        View payment history
        </a>
      </div> 
    `
    this.init()
  }

  init() {
    this.querySelector('#view_payment_history').onclick = this.viewPaymentHistory.bind(this);
  }

  viewPaymentHistory() {
    console.log('viewPaymentHistory ', this.groupId)
      const containerIdSelector = 'group_editor_billing_info_container'
      document.getElementById(containerIdSelector).style.display = 'none';
      let paymentHistory = new SimplePaymentHistory(this.groupId, containerIdSelector);
      document.getElementById('simple_payment_history_container').innerHTML = '';
      document.getElementById('simple_payment_history_container').appendChild(paymentHistory);
  }
}
customElements.define('next-due-date', NextDueDate)